import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceDelta',
})
export class PriceDeltaPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value.comparisonPrice == 0 && value.defaultPrice == 0) {
      return '';
    }

    if (value.defaultPrice < value.comparisonPrice) {
      let decrease = value.comparisonPrice - value.defaultPrice;
      let pDecrease = (decrease / value.comparisonPrice) * 100;
      return '+' + pDecrease.toFixed(2) + '%';
    } else {
      let increase = value.defaultPrice - value.comparisonPrice;
      let pIncrease = (increase / value.defaultPrice) * 100;
      return '-' + pIncrease.toFixed(2) + '%';
    }
  }
}
